module.exports = __webpack_public_path__ + "media/images/vp/icon.star.blue-bdec4ac8c0201c576f2f5283a278ff71.svg";